import React, { useEffect, createElement } from 'react';
import { UrgencyBanner } from './components/UrgencyBanner';
import { AttentionBanner } from './components/AttentionBanner';
import { HeroSection } from './components/HeroSection';
import { ProblemSection } from './components/ProblemSection';
import { ContentSection } from './components/ContentSection';
import { PreviewCarousel } from './components/PreviewCarousel';
import { TestimonialsSection } from './components/TestimonialsSection';
import { PricingSection } from './components/PricingSection';
import { ClosingSection } from './components/ClosingSection';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    // Meta Pixel - direct injection (more reliable than react-facebook-pixel)
    const pixelId = '1926254961581528';
    if (!(window as any).fbq) {
      const f = window as any;
      const n = f.fbq = function (...args: any[]) {
        n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [] as any[];
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(script);
      f.fbq('init', pixelId);
      f.fbq('track', 'PageView');
    }
  }, []);
  return <div className="min-h-screen bg-white font-sans scroll-smooth" data-id="element-0">
      <UrgencyBanner data-id="element-1" />
      <AttentionBanner data-id="element-2" />

      {/* Main content wrapper with top padding to account for fixed banners (32px + 36px = 68px) */}
      <main className="pt-[68px]" data-id="element-3">
        <HeroSection data-id="element-4" />
        <ProblemSection data-id="element-5" />
        <ContentSection data-id="element-6" />
        <PreviewCarousel data-id="element-7" />
        <TestimonialsSection data-id="element-8" />
        <PricingSection data-id="element-9" />
        <ClosingSection data-id="element-10" />
      </main>

      <Footer data-id="element-11" />
    </div>;
}